import { Helmet } from 'react-helmet-async';
import React from 'react';
import { FormControl } from 'react-bootstrap';
import SubHeader from '../SubHeader.jsx';
import VerticalSeparator from '../VerticalSeparator.jsx';
import { EmployeeLink } from '../links/index.jsx';
import OrganizationHeader from '../headers/PageHeaders/Organization/OrganizationHeader.jsx';

const EmployeeProfileHeader = ({
  employee,
  employeeUser,
  currentUser,
  permissions,
  searchValue,
  appliedSearch,
  onSearchChange,
}) => {
  const { fullName, group, avatar, email, archived, parentName, parentId } =
    employee;

  return (
    <React.Fragment>
      <Helmet>
        <title>{fullName} | ChangeSync</title>
      </Helmet>

      <OrganizationHeader
        profileTabs
        userId={employeeUser ? employeeUser.id : null}
        currentUserId={currentUser.id}
        employeeId={employee.id}
        employeeName={employee.fullName}
        permissions={permissions}
        profileSearch={appliedSearch}
      />

      <SubHeader flexJustify small>
        <div className="flex flex-align-stretch">
          <div
            className={`profile-avatar m-r-30 ${archived ? 'archived' : ''}`}
          >
            <img src={avatar} alt="avatar" />
          </div>
          <div className="flex flex-col flex-align-start flex-center">
            <div className="flex flex-align-center m-b-12">
              <h2 className={archived ? 'text-mute' : ''}>{fullName}</h2>
              <VerticalSeparator customClasses="m-l-18 m-r-18" />
              <strong className="text-muted m-r-12 text-capitalize">
                Email:
              </strong>
              <strong>{email}</strong>
            </div>
            <div className="flex">
              <strong className="text-muted m-r-12 text-capitalize">
                Group:
              </strong>
              <strong>{group ? group.name : '—'}</strong>
              <VerticalSeparator customClasses="m-l-18 m-r-18" />
              <strong className="text-muted m-r-12 text-capitalize">
                Supervisor:
              </strong>
              <strong>
                {parentId ? (
                  <EmployeeLink employeeId={parentId}>
                    {parentName}
                  </EmployeeLink>
                ) : (
                  '—'
                )}
              </strong>
            </div>
          </div>
        </div>

        <div className="flex flex-end" style={{ width: '50%' }}>
          <div
            className="m-r-16 m-l-12"
            style={{ width: '100%', maxWidth: '540px' }}
          >
            <FormControl
              placeholder="Search"
              type="text"
              value={searchValue}
              onChange={(event) => onSearchChange(event.target.value)}
            />
          </div>
        </div>
      </SubHeader>
    </React.Fragment>
  );
};

export default EmployeeProfileHeader;
